module.exports = __webpack_public_path__ + "static/media/W.b1f38493.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/components/atoms/Phonics/W.mp3
// module id = 244
// module chunks = 0